import { FEATURE_FLAGS, useFlags } from "@contexts/FeatureFlagContext"
import { TagsList } from "@components/Listings/ListingsFilter/components/ListingsFilterCheckboxList"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import { useMemo } from "react"
import { brokerNotActiveStatuses } from "@utils/const"
import { useFilterData } from "@components/Listings/ListingsFilter/FilterDataContextProvider"

export function TagsBrokerStatus() {
    const flags = useFlags()
    const onTagListChange = useFilterStore((s) => s.onTagListChange)
    const filterData = useFilterData()
    const items = useMemo(() => {
        const bs = (filterData?.listingFilter?.broker_status?.split(";") || []).map((i) => ({ key: i }))
        return bs.filter((i) => !brokerNotActiveStatuses.includes(i.key))
    }, [filterData])
    return flags[FEATURE_FLAGS.brokerStatus] ? <TagsList items={items} onItemChange={onTagListChange("broker_status")} title="Broker Status" /> : null
}
